import { render, staticRenderFns } from "./InvoiceDetail.vue?vue&type=template&id=2f9506b8&scoped=true&"
import script from "./InvoiceDetail.vue?vue&type=script&setup=true&lang=ts&"
export * from "./InvoiceDetail.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./InvoiceDetail.vue?vue&type=style&index=0&id=2f9506b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9506b8",
  null
  
)

export default component.exports